// import invariant from 'invariant';
import { createReducers } from 'store/reducer';

export function injectReducerFactory(store) {
  return function injectReducer(key, reducer) {
    store.graphqlInjectedReducers[key] = reducer; // eslint-disable-line no-param-reassign
    store.replaceReducer(createReducers(store.graphqlInjectedReducers));
  };
}

export default function getInjectors(store) {
  return {
    injectReducer: injectReducerFactory(store, true),
  };
}
